import Skeleton from './skeleton';

export default Skeleton;
export type * from './types';
